/**
 * Runtime environment accessor.
 *
 * vite.config.js `define` inlines REACT_APP_* as string literals at build
 * time, which freezes a single `vite build` artefact to one backend. To let
 * the same build run against different environments, `public/env-config`
 * (served extensionless so CDNs don't cache it; regenerated on the host from
 * `.env` — see scripts/generate-env-config.sh) sets `window._env_` *before*
 * the app bundle executes. Runtime wins; the build-time inlined value is the
 * fallback for `npm start` and for deploys that leave env-config as placeholders.
 */

// Static member access so Vite's `define` can inline these at build time.
const BUILD_TIME = {
  REACT_APP_DOMAIN: process.env.REACT_APP_DOMAIN,
  REACT_APP_RSA_PUBLIC_KEY: process.env.REACT_APP_RSA_PUBLIC_KEY,
};

export function getEnv(key) {
  const runtime =
    typeof window !== "undefined" && window._env_ ? window._env_[key] : undefined;
  // A placeholder env-config ships empty strings — treat those as "unset"
  // and fall back to the build-time value.
  return runtime || BUILD_TIME[key] || "";
}
